import { JobListing } from './../../jobs-module/models/listing.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { speedDialFabAnimations } from './mj-listing-fab.animations';
import { buttons } from './mj-listing-fab.config';

@Component({
  selector: 'mj-listing-fab',
  templateUrl: './mj-listing-fab.component.html',
  styleUrls: ['./mj-listing-fab.component.scss'],
  animations: speedDialFabAnimations,
})
export class MjListingFabComponent {
  @Input() public listing: JobListing;
  @Output() public onPresentSortableContainer = new EventEmitter<boolean>();
  public fabSelected: string;
  public fabButtons = buttons;
  public buttons = [];
  public fabTogglerState = 'inactive';
  public rearrangeEnabled = false;
  public paintEnabled = { isOn: false };

  public showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  public hideItems() {
    this.fabSelected = null;
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  public onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

  public onFabClick(btn) {
    this.onToggleFab(); // TODO remove this line when we wont need commented code
    this.fabSelected = this.fabSelected === btn.name ? null : btn.name;
    switch (btn.name) {
      case 'paint':
        this.paintClicked();
        break;
      case 'rearrange':
        this.rearrangeClicked();
        break;

      case 'font':
        this.changeFontClicked();
        break;
      case 'separator':
        this.separatorClicked();
        break;
    }
  }

  public setColor(color: string) {
    this.listing.global_background_rgba = color;
  }

  private rearrangeClicked() {
    this.rearrangeEnabled = !this.rearrangeEnabled;
    this.onPresentSortableContainer.emit(this.rearrangeEnabled);
  }

  private paintClicked() {
    this.paintEnabled.isOn = !this.paintEnabled.isOn;
  }

  private changeFontClicked() {
    // Todo add functionality
  }

  private separatorClicked() {
    // Todo add functionality
  }
}
